import { X } from 'lucide-react';

import { useTheme } from '../../hooks/useTheme';

import { NAV_THEMES } from './nav-tokens';
import NebariLogoMark from './NebariLogoMark';

interface NavDrawerHeaderProps {
  onClose: () => void;
}

/** The drawer's own header: the brand, and the close control. Without it the
 *  drawer opens straight onto a section row and the only ways out are the
 *  scrim, Escape and the More tab — none of them visible. */
export default function NavDrawerHeader({ onClose }: NavDrawerHeaderProps) {
  const { theme } = useTheme();
  const t = NAV_THEMES[theme];
  return (
    <div
      className="flex h-14 shrink-0 items-center gap-2.5 px-3"
      style={{ color: t.ink, borderBottom: `1px solid ${t.border}` }}
    >
      <NebariLogoMark size={32} />
      <span className="flex-1 truncate text-base font-bold -tracking-[0.2px]">Nebari</span>
      <button
        type="button"
        onClick={onClose}
        aria-label="Close navigation"
        className="flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-[10px] border-0"
        style={{ background: t.surface, color: t.muted }}
      >
        <X size={18} aria-hidden />
      </button>
    </div>
  );
}
